import { render, staticRenderFns } from "./reportePtiPresentadosV2.vue?vue&type=template&id=861b066c&scoped=true"
import script from "./reportePtiPresentadosV2.vue?vue&type=script&lang=js"
export * from "./reportePtiPresentadosV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861b066c",
  null
  
)

export default component.exports